<template lang="pug">
v-navigation-drawer.z-50(v-model="showDrawer" mobile-breakpoint="xs" width="375" temporary right app)
  div
    KeepAlive(include="main")
      .px-6.d-flex.flex-column(v-if="page === 'main'")
        .d-flex.align-center.top-0.sticky.z-10.white.py-6
          .heading-5 {{ $t('add_filter') }}
          v-spacer
          .link-s(v-if="allFilters.length" @click="clearFilters") {{ $t('clear_all_filters') }}
        .mt-4
          v-sheet.round-xl.mb-4.border-dropdown(v-for="item in items" @click="openDetail(item.type)" :key="item.type" :class="getFilterData(item.type) ? 'border-selected' : ''" outlined)
            .d-flex.align-center.hover-bg.pa-4
              div
                .text-md.font-medium.text-none.neutral700--text Filter {{ item.name }}
                .text-sm.neutral500--text.mt-1.pre-wrap(v-if="getFilterData(item.type)") {{ getFilterData(item.type) }}
              v-spacer
              v-menu(offset-y min-width=200 v-if="getFilterData(item.type)")
                template(v-slot:activator="{ on, attrs }")
                  v-btn(v-on="on" color="primary400" icon small)
                    v-icon mdi-dots-horizontal
                v-list.py-0
                  v-list-item(@click="openDetail(item.type)")
                    .text-sm Edit Filter
                  v-divider.basic300
                  v-list-item(@click="deleteFilter(item.type)")
                    .text-sm.danger500--text Delete Filter
              eva-icon(v-else name="arrow-ios-forward" fill="#888")
        .py-12
          .yc-fixed-bottom-section
            .px-3.py-2
              v-btn.button-md.white--text(@click="clickDone" color="info500" block depressed) {{ $t('done') }}

      filter-rating(v-else-if="page === 'rating'" :filter.sync="ratingFilter" @onBack="back")
      filter-alphanumeric(v-else-if="page === 'name'" type="name" :filter.sync="nameFilter" @onBack="back")
      filter-reply-status(v-else-if="page === 'replyStatus'" :filter.sync="replyStatusFilter" @onBack="back")
      filter-date(v-else-if="page === 'date'" :title="$t('filter_last_update')" :description="$t('filter_review_made_on')" :filter.sync="dateFilter" @onBack="back")
</template>

<script>
import FilterRating from '@/components/review/filter/FilterRating.vue'
import FilterAlphanumeric from '@/components/review/filter/FilterAlphanumeric.vue'
import FilterReplyStatus from '@/components/review/filter/FilterReplyStatus.vue'
import FilterDate from '@/components/review/filter/FilterDate.vue'

export default {
  name: 'FilterGoogleReviewDrawer',
  components: {
    FilterRating,
    FilterAlphanumeric,
    FilterReplyStatus,
    FilterDate
  },
  props: {
    open: {
      type: Boolean
    },
  },
  data() {
    return {
      page: 'main',
      items: [
        { name: 'Rating', type: 'rating' },
        { name: 'Name', type: 'name' },
        { name: 'Reply Status', type: 'replyStatus' },
        { name: 'Date', type: 'date' },
      ],
      ratingFilter: {},
      nameFilter: {},
      replyStatusFilter: {},
      dateFilter: {},
    }
  },
  computed: {
    showDrawer: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    allFilters() {
      const filters = []
      if (this.ratingFilter?.items) {
        let list = this.ratingFilter.items.join(',')
        filters.push({ key: 'star', value: list })
      }
      if (this.nameFilter?.all) {
        filters.push({ key: 'name__contains', value: this.nameFilter.all })
      }
      if (this.nameFilter?.exact) {
        filters.push({ key: 'name', value: this.nameFilter.exact })
      }
      if (this.nameFilter?.none) {
        filters.push({ key: 'name__exclude', value: this.nameFilter.none })
      }
      if (this.replyStatusFilter?.items) {
        let list = this.replyStatusFilter.items.join(',')
        filters.push({ key: 'replied', value: list })
      }
      if (this.dateFilter?.before) {
        filters.push({ key: 'posted__before', value: this.dateFilter.before })
      }
      if (this.dateFilter?.after) {
        filters.push({ key: 'posted__after', value: this.dateFilter.after })
      }
      if (this.dateFilter?.exact) {
        filters.push({ key: 'posted__on', value: this.dateFilter.exact })
      }
      if (this.dateFilter?.between) {
        filters.push({ key: 'posted__after', value: this.dateFilter.between.start })
        filters.push({ key: 'posted__before', value: this.dateFilter.between.end })
      }
      return filters
    }
  },
  methods: {
    openDetail(page) {
      this.page = page
    },
    getFilterData(type) {
      switch (type) {
        case 'rating': {
          const length = this.ratingFilter?.items?.length
          if (length) {
            return `${length} ${this.$options.filters.pluralize('rating', { count:length })} selected`
          }
          break
        }

        case 'name': {
          const obj = this.nameFilter
          const changes = []
          for (const key in obj) {
            const val = obj[key]
            if (val) {
                const name = this.getNameFromFilterKey(key)
                let description = val
                changes.push(`${name} ${description}`)
            }
          }
          if (changes.length) {
            return changes.join('\n')
          }
          return null
        }

        case 'replyStatus': {
          const length = this.replyStatusFilter?.items?.length
          if (length) {
            return `${length} ${this.$options.filters.pluralize('reply status', { count:length, esForm:true })} selected`
          }
          break
        }

        case 'date': {
          let changes = []
          for (const key in this.dateFilter) {
            const val = this.dateFilter[key]
            const name = this.getNameFromFilterKey(key, 'date')
            if (val) {
              if (key === 'between') {
                changes.push(`${name} ${val.start} - ${val.end}`)
              } else {
                changes.push(`${name} ${val} `)
              }
            }
          }
          if (changes.length) {
            return changes.join('\n')
          }
          return null
        }

        default:
          return null
      }
    },
    getNameFromFilterKey(key, type){
      switch(key) {
        case 'all':
          return 'All of these words:'
        case 'exact':
          return type === 'date' ? 'Exact' :'Exact word:'
        case 'none':
          return 'None of these words:'
        case 'before':
          return 'Before'
        case 'after':
          return 'After'
        case 'between':
          return 'In between'
      }
      return key
    },
    clearFilters () {
      this.ratingFilter = {}
      this.nameFilter = {}
      this.replyStatusFilter = {}
      this.dateFilter = {}
    },
    deleteFilter(type) {
      switch (type) {
        case 'rating':
          this.ratingFilter = {}
          break

        case 'name':
          this.nameFilter = {}
          break

        case 'replyStatus':
          this.replyStatusFilter = {}
          break

        case 'date':
          this.dateFilter = {}
          break
      }
    },
    back() {
      this.page = 'main'
    },
    clickDone() {
      this.$emit('done', this.allFilters)
      this.showDrawer = false
    },
  },
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close), 
.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  box-shadow: unset !important;
}
.v-navigation-drawer--bottom.v-navigation-drawer--is-mobile {
  max-height: 100% !important;
}
.pre-wrap {
  white-space: pre-wrap;
}
</style>